import {HttpParams} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {iif, map, Observable, of, switchMap, throwError} from "rxjs";
import {IosBridgeBase} from "../../../../mobile/api-services/bridge/ios-bridge-base";
import {HttpMethod, HttpRequest, HttpResponse, Platform} from "../../../../constraints";
import {CasaMobileBaseService} from "./casa-mobile-base.service";

@Injectable({
  providedIn: 'root'
})
export class CasaIosService extends CasaMobileBaseService {
  constructor(
    private bridge: IosBridgeBase
  ) {
    super();
  }

  private appendParams(path: string, params: HttpParams): string {
    if (!params || params.keys().length === 0) return path;
    const query = params.keys()
      .map(key => params.getAll(key)?.map(value =>
        `${encodeURIComponent(key)}=${encodeURIComponent(value ?? "")}`).join("&"))
      .filter(Boolean)
      .join("&");
    return query ? `${path}?${query}` : path;
  }

  protected request<T>(method: HttpMethod, path: string, body?: any, params?: HttpParams): Observable<T> {
    const finalPath = this.appendParams(path, params ?? new HttpParams());
    const requestBody = body === null || body === undefined ? null : JSON.stringify(body);
    const request = new HttpRequest(Platform.Events, method, finalPath, null, requestBody);
    return this.bridge.callForResponse<HttpResponse>("exchange", {request}).pipe(
      switchMap((response) => iif(
        () => response.responseCode >= 200 && response.responseCode < 300,
        of(response.body),
        throwError(() => Error(`Error with code ${response.responseCode}`))
      )),
      map((raw) => {
        if (!raw) return null as T;
        return JSON.parse(raw) as T;
      })
    );
  }
}
